module.exports = __webpack_public_path__ + "static/media/appointment_photo.170d2cca.png";